import { Box } from "@mui/material";

import AvatarList from "../../AvatarList";

const AboutParticipants = ({ about }) => {
  return (
    <>
      {!about?.summarized && (
        <Box sx={{ marginBottom: "22px", pt: "5px" }}>
          <AvatarList avatarData={about} type='table' size={60} showProfile />
        </Box>
      )}
    </>
  );
};
export default AboutParticipants;
